export const GATEWAY_AUTH_PATH_NAME = 'auth';
